const WEB3FORMS_URL = 'https://api.web3forms.com/submit';

function accessKey() {
  try {
    return String(__WEB3FORMS_ACCESS_KEY__ || '');
  } catch (error) {
    return '';
  }
}

function endpoint() {
  try {
    return String(__FORM_ENDPOINT__ || WEB3FORMS_URL);
  } catch (error) {
    return WEB3FORMS_URL;
  }
}

function setStatus(status, message, kind) {
  if (!status) return;
  status.className = 'form-status';
  if (kind) status.classList.add(kind);
  status.textContent = message;
}

export function initForms() {
  const params = new URLSearchParams(window.location.search);
  const preset = params.get('intent');
  if (preset) {
    const select = document.querySelector('#intent');
    if (select) select.value = preset;
  }

  document.querySelectorAll('[data-intake-form]').forEach((form) => {
    const submitBtn = form.querySelector('button[type="submit"]');

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const status = form.querySelector('[data-form-status]');
      const key = accessKey();
      const url = endpoint();

      if (!key) {
        setStatus(status, 'Could not send — the intake key is missing.', 'is-err');
        return;
      }

      const formData = new FormData(form);
      formData.append('access_key', key);
      formData.append('subject', `Deliniext contact — ${formData.get('intent') || 'sales'}`);
      formData.append('from_name', formData.get('name') || 'Deliniext website');
      formData.append('source', 'deliniext-website');

      const originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.textContent = 'Sending...';
        submitBtn.disabled = true;
      }
      setStatus(status, 'Sending…');

      try {
        const response = await fetch(url, {
          method: 'POST',
          body: formData,
        });
        const data = await response.json();

        if (response.ok && data.success !== false) {
          setStatus(status, 'Received. A Restora operator will reply.', 'is-ok');
          form.reset();
        } else {
          setStatus(status, data.message || 'Could not send. Try again or email sales.', 'is-err');
        }
      } catch (error) {
        setStatus(status, 'Something went wrong. Please try again.', 'is-err');
        console.warn(error);
      } finally {
        if (submitBtn) {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }
      }
    });
  });
}
